(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const createRail = (section) => {
      if (instances.has(section)) return;

      const rail = section.querySelector('[data-ot-editorial-rail]');
      const controls = section.querySelector('[data-ot-editorial-controls]');
      if (!rail || !controls) return;

      const items = Array.from(rail.querySelectorAll('.ot-editorial__item'));
      const previous = controls.querySelector('[data-ot-editorial-previous]');
      const next = controls.querySelector('[data-ot-editorial-next]');
      const current = controls.querySelector('[data-ot-editorial-current]');
      const status = controls.querySelector('[data-ot-editorial-status]');
      if (items.length < 2 || !previous || !next || !current || !status) return;

      let currentIndex = 0;
      let frame;

      const closestIndex = () => {
        const railLeft = rail.getBoundingClientRect().left;
        let closest = 0;
        let smallestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - railLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            closest = index;
          }
        });

        return closest;
      };

      const update = (announce = false) => {
        const nextIndex = closestIndex();
        const changed = nextIndex !== currentIndex;
        currentIndex = nextIndex;
        current.textContent = String(currentIndex + 1);
        previous.disabled = currentIndex === 0;
        next.disabled = currentIndex === items.length - 1;

        if (announce && changed) {
          status.textContent = `Collection ${currentIndex + 1} of ${items.length}`;
        }
      };

      const scheduleUpdate = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => update(true));
      };

      const moveTo = (index) => {
        const target = items[Math.max(0, Math.min(index, items.length - 1))];
        if (!target) return;

        target.scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      };

      const handlePrevious = () => moveTo(currentIndex - 1);
      const handleNext = () => moveTo(currentIndex + 1);
      const resizeObserver = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(scheduleUpdate);

      previous.addEventListener('click', handlePrevious);
      next.addEventListener('click', handleNext);
      rail.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      resizeObserver?.observe(rail);
      update();

      instances.set(section, {
        moveTo,
        destroy() {
          window.cancelAnimationFrame(frame);
          previous.removeEventListener('click', handlePrevious);
          next.removeEventListener('click', handleNext);
          rail.removeEventListener('scroll', scheduleUpdate);
          window.removeEventListener('resize', scheduleUpdate);
          resizeObserver?.disconnect();
        }
      });
    };

    const initialize = (container = document) => {
      if (container.matches?.('[data-ot-editorial-section]')) createRail(container);
      container.querySelectorAll?.('[data-ot-editorial-section]').forEach(createRail);
    };

    const unload = (container) => {
      const sections = container.matches?.('[data-ot-editorial-section]')
        ? [container]
        : Array.from(container.querySelectorAll?.('[data-ot-editorial-section]') || []);

      sections.forEach((section) => {
        instances.get(section)?.destroy();
        instances.delete(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => unload(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest?.('.ot-editorial__item');
      const section = item?.closest('[data-ot-editorial-section]');
      if (!item || !section) return;

      const items = Array.from(section.querySelectorAll('.ot-editorial__item'));
      instances.get(section)?.moveTo(items.indexOf(item));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-core-edit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-scene-toggle]');
    if (!button) return;
    const card = button.closest('.ot-edit__card');
    const show = button.getAttribute('aria-pressed') !== 'true';
    card.dataset.scene = String(show);
    button.setAttribute('aria-pressed', String(show));
    button.textContent = show ? button.dataset.product : button.dataset.room;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!window.__otFeaturedProductsRailBound) {
    window.__otFeaturedProductsRailBound = true;

    (() => {
      const instances = new WeakMap();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const initializeRail = (scope) => {
        const rail = scope.matches?.('[data-ot-product-rail]') ? scope : scope.querySelector?.('[data-ot-product-rail]');
        if (!rail || instances.has(rail)) return;

        const root = rail.closest('.ot-featured-products');
        const controls = root?.querySelector('[data-ot-product-rail-controls]');
        const cards = Array.from(rail.querySelectorAll('.ot-featured-products__card'));
        if (!controls || cards.length < 2) return;

        const previous = controls.querySelector('[data-ot-product-rail-previous]');
        const next = controls.querySelector('[data-ot-product-rail-next]');
        const current = controls.querySelector('[data-ot-product-rail-current]');
        const progress = controls.querySelector('[data-ot-product-rail-progress]');
        const status = controls.querySelector('[data-ot-product-rail-status]');
        if (!previous || !next || !current || !progress || !status) return;

        let currentIndex = 0;
        let frame;

        const getIndex = () => {
          let closestIndex = 0;
          let closestDistance = Infinity;
          cards.forEach((card, index) => {
            const distance = Math.abs(card.offsetLeft - rail.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          return closestIndex;
        };

        const update = (announce = false) => {
          const nextIndex = getIndex();
          const changed = nextIndex !== currentIndex;
          currentIndex = nextIndex;
          current.textContent = String(currentIndex + 1);
          previous.disabled = currentIndex === 0;
          next.disabled = currentIndex === cards.length - 1;
          progress.style.setProperty('--ot-rail-progress', String((currentIndex + 1) / cards.length));
          if (announce && changed) status.textContent = `Product ${currentIndex + 1} of ${cards.length}`;
        };

        const scheduleUpdate = () => {
          if (frame) return;
          frame = window.requestAnimationFrame(() => {
            frame = undefined;
            update(true);
          });
        };

        const move = (direction) => {
          const targetIndex = Math.max(0, Math.min(cards.length - 1, getIndex() + direction));
          cards[targetIndex].scrollIntoView({
            behavior: reduceMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'start'
          });
        };

        const onPrevious = () => move(-1);
        const onNext = () => move(1);
        const resizeObserver = new ResizeObserver(() => update(false));

        previous.addEventListener('click', onPrevious);
        next.addEventListener('click', onNext);
        rail.addEventListener('scroll', scheduleUpdate, { passive: true });
        resizeObserver.observe(rail);
        update(false);

        instances.set(rail, () => {
          previous.removeEventListener('click', onPrevious);
          next.removeEventListener('click', onNext);
          rail.removeEventListener('scroll', scheduleUpdate);
          resizeObserver.disconnect();
          if (frame) window.cancelAnimationFrame(frame);
          instances.delete(rail);
        });
      };

      document.querySelectorAll('[data-ot-product-rail]').forEach(initializeRail);
      document.addEventListener('shopify:section:load', (event) => initializeRail(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll?.('[data-ot-product-rail]').forEach((rail) => instances.get(rail)?.());
      });
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ot-hero-carousel')) {
    customElements.define('ot-hero-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = [...this.querySelectorAll('.ot-hero__slide')];
        this.selectors = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.toggle = this.querySelector('[data-toggle]');
        if (this.slides.length < 2) return;
        this.querySelector('.ot-hero__controls').hidden = false;
        this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1, true), {signal});
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1, true), {signal});
        this.selectors.forEach((button, i) => button.addEventListener('click', () => this.show(i, true), {signal}));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.renderToggle();
          this.schedule();
        }, {signal});
        this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, {signal});
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
        this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.schedule(); } }, {signal});
        this.addEventListener('keydown', e => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            this.show(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, {signal});
        const surface = this.querySelector('.ot-hero__slides');
        surface.addEventListener('pointerdown', e => { this.start = {x:e.clientX, y:e.clientY}; }, {signal});
        surface.addEventListener('pointerup', e => {
          if (!this.start) return;
          const dx = e.clientX - this.start.x;
          const dy = e.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
        }, {signal});
        surface.addEventListener('pointercancel', () => { this.start = null; }, {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.renderToggle();
          this.schedule();
        }, {signal});
        this.addEventListener('shopify:block:select', e => {
          const i = this.slides.indexOf(e.target.closest('.ot-hero__slide'));
          if (i >= 0) this.show(i, true);
        }, {signal});
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, {threshold:0.15});
        this.observer.observe(this);
        this.renderToggle();
        this.schedule();
      }
      show(next, manual = false) {
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
          } else slide.setAttribute('aria-hidden', 'true');
          if (active) this.selectors[i].setAttribute('aria-current', 'true');
          else this.selectors[i].removeAttribute('aria-current');
        });
        if (manual) {
          this.paused = true;
          this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
          this.renderToggle();
        }
        this.schedule();
      }
      renderToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
        this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
        this.dataset.autoplay = this.paused ? 'paused' : 'enabled';
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && !document.hidden && this.inView && !this.motion.matches) {
          this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval));
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!window.__otNewsletterPopupBound) {
    window.__otNewsletterPopupBound = true;

    const storage = {
      get(area, key) {
        try {
          return area.getItem(key);
        } catch (error) {
          return null;
        }
      },
      set(area, key, value) {
        try {
          area.setItem(key, value);
        } catch (error) {
          return;
        }
      },
      remove(area, key) {
        try {
          area.removeItem(key);
        } catch (error) {
          return;
        }
      }
    };

    const bindPopup = (dialog) => {
      if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.otBound === 'true') return;

      dialog.dataset.otBound = 'true';

      const closeButton = dialog.querySelector('[data-ot-newsletter-close]');
      const emailInput = dialog.querySelector('input[type="email"]');
      const form = dialog.querySelector('form');
      const hasSuccess = Boolean(dialog.querySelector('[data-ot-newsletter-success]'));
      const hasError = Boolean(dialog.querySelector('[data-ot-newsletter-error]'));
      const designMode = dialog.dataset.designMode === 'true';
      const delay = Math.max(Number(dialog.dataset.delay) || 8, 0);
      const scrollDepth = Math.max(Number(dialog.dataset.scrollDepth) || 15, 0);
      const dismissDays = Math.max(Number(dialog.dataset.dismissDays) || 30, 1);
      const stateKey = `ot-newsletter-popup:${dialog.id}:v1`;
      const submitKey = `${stateKey}:submitting`;
      const scrollRoot = document.querySelector('.page-wrapper') || document.scrollingElement;
      const usesWindowScroll = scrollRoot === document.documentElement || scrollRoot === document.body;
      const scrollTarget = usesWindowScroll ? window : scrollRoot;
      let delayReady = false;
      let scrollReady = scrollDepth === 0;
      let triggerTimer;
      let previousFocus;

      const readState = () => {
        const rawState = storage.get(window.localStorage, stateKey);
        if (!rawState) return null;

        try {
          const parsedState = JSON.parse(rawState);
          if (!parsedState.expires || Date.now() >= parsedState.expires) {
            storage.remove(window.localStorage, stateKey);
            return null;
          }
          return parsedState;
        } catch (error) {
          storage.remove(window.localStorage, stateKey);
          return null;
        }
      };

      const writeState = (value, days) => {
        storage.set(window.localStorage, stateKey, JSON.stringify({
          value,
          expires: Date.now() + days * 86400000
        }));
      };

      const stopTriggers = () => {
        window.clearTimeout(triggerTimer);
        scrollTarget?.removeEventListener('scroll', updateScroll);
      };

      const showPopup = () => {
        if (!dialog.isConnected || dialog.open) return;
        previousFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('ot-newsletter-popup-open');
        window.requestAnimationFrame(() => emailInput?.focus({ preventScroll: true }));
      };

      const maybeOpen = () => {
        if (!delayReady || !scrollReady || readState()) return;
        stopTriggers();
        showPopup();
      };

      const updateScroll = () => {
        const scrollTop = usesWindowScroll ? window.scrollY : scrollRoot.scrollTop;
        const scrollHeight = usesWindowScroll ? document.documentElement.scrollHeight : scrollRoot.scrollHeight;
        const clientHeight = usesWindowScroll ? window.innerHeight : scrollRoot.clientHeight;
        const scrollableDistance = Math.max(scrollHeight - clientHeight, 1);
        const currentDepth = (scrollTop / scrollableDistance) * 100;
        if (scrollTop >= 64 && currentDepth >= scrollDepth) {
          scrollReady = true;
          maybeOpen();
        }
      };

      const submittedHere = storage.get(window.sessionStorage, submitKey) === '1';

      closeButton?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ot-newsletter-popup-open');
        stopTriggers();
        if (!hasSuccess) writeState('dismissed', dismissDays);
        if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
      });

      if (hasSuccess) {
        writeState('subscribed', 365);
        storage.remove(window.sessionStorage, submitKey);
        if (submittedHere) showPopup();
        return;
      }

      if (hasError) {
        storage.remove(window.sessionStorage, submitKey);
        if (submittedHere) showPopup();
        return;
      }

      if (designMode) {
        showPopup();
        return;
      }

      if (readState()) return;

      form?.addEventListener('submit', () => {
        storage.set(window.sessionStorage, submitKey, '1');
      });

      triggerTimer = window.setTimeout(() => {
        delayReady = true;
        maybeOpen();
      }, delay * 1000);

      scrollTarget?.addEventListener('scroll', updateScroll, { passive: true });
      updateScroll();
    };

    const initializePopups = (root = document) => {
      root.querySelectorAll('[data-ot-newsletter-popup]').forEach(bindPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializePopups(), { once: true });
    } else {
      initializePopups();
    }

    document.addEventListener('shopify:section:load', (event) => initializePopups(event.target));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ot-premium-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.__otPremiumHeroScrollBound) {
    window.__otPremiumHeroScrollBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-ot-scroll-next]');
      if (!trigger) return;

      const sectionWrapper = trigger.closest('.shopify-section');
      const nextSection = sectionWrapper ? sectionWrapper.nextElementSibling : null;
      if (!nextSection) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      nextSection.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
